import React from 'react';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const BankTransferStatus = () => {
    const { gotIt, title, subTitle1 } = usePageMessages();
    const { nextPageLink, isPaid, paid, notNow } = useExtra();

    return (
        <BaseLayout showChat={false}>
            <InfoPage
                iconName={isPaid && paid ? 'clock-80' : notNow ? 'zap-80' : null}
                iconColor="primary"
                headerText={<DangerouslyHtml dangerouslyHtml={title} />}
                secondaryText={<DangerouslyHtml dangerouslyHtml={subTitle1} />}
                primaryButtonCaption={gotIt}
                primaryButtonType="link"
                primaryButtonLink={nextPageLink}
            />
        </BaseLayout>
    );
};

export default BasePage(BankTransferStatus);
